// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.W_VA02KDjuFGny {
  margin: var(--ds-space-0, 0) -12px;
  padding: var(--ds-space-400, 32px);
  background-color: var(--ds-surface-sunken, #f7f8f9);
}
.W_VA02KDjuFGny.PgKw1gQCVZJQWW {
  margin: var(--ds-space-0, 0);
}
.dJTS3FCwC6Plhw {
  display: flex;
  justify-content: space-between;
}
`, ""]);
// Exports
export var labelPreview = `W_VA02KDjuFGny`;
export var isSourceSidebarMenu = `PgKw1gQCVZJQWW`;
export var footer = `dJTS3FCwC6Plhw`;
export default ___CSS_LOADER_EXPORT___;
